import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Soy muy joven para aprender esto?',
  a: 'Nunca es pronto para desarrollar buenos hábitos. Si gestionas recursos, ya eres un administrador. Cuanto antes entiendas las reglas del juego, mejor será tu posición.'
}, {
  q: '¿Necesito mucho capital para empezar?',
  a: 'No. El sistema se basa en hábitos, no en montos. Funciona exactamente igual con $1 que con $1,000.'
}, {
  q: '¿Es aburrido?',
  a: 'Para nada. Está diseñado con un lenguaje claro, párrafos breves y una estructura visual pensada para la atención de hoy.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4" data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 font-orbitron" data-id="element-35">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-36">
          {faqs.map((faq, idx) => <div key={idx} className={`glass-panel rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === idx ? 'border-[#39FF14]/50 bg-white/5' : 'border-white/10'}`} data-id="element-37">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-38">
                <span className={`font-bold text-lg ${openIndex === idx ? 'text-[#39FF14]' : 'text-white'}`} data-id="element-39">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`transform transition-transform duration-300 ${openIndex === idx ? 'rotate-180 text-[#39FF14]' : 'text-gray-400'}`} data-id="element-40" />
              </button>

              <AnimatePresence data-id="element-41">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-42">
                    <div className="px-6 pb-5 text-gray-300 leading-relaxed" data-id="element-43">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}